import { render } from "./session-tag-limit-alert.vue?vue&type=template&id=30031cf3&lang=pug"
import script from "./session-tag-limit-alert.vue?vue&type=script&lang=js"
export * from "./session-tag-limit-alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__